export default __webpack_public_path__ + "static/media/Datacor_Products_Logo_Selected_Outlined_RGB_ERP_Light.522798f5.png";